// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalContainer__modalLayer____0JRW {
    /* Искусственно создаем stacking-context, чтобы z-index модалок стал локальным для контейнера */
    isolation: isolate;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalContainer/ModalContainer.css"],"names":[],"mappings":"AAAA;IACI,+FAA+F;IAC/F,kBAAkB;AACtB","sourcesContent":[".modalLayer {\n    /* Искусственно создаем stacking-context, чтобы z-index модалок стал локальным для контейнера */\n    isolation: isolate;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalLayer": `ModalContainer__modalLayer____0JRW`
};
export default ___CSS_LOADER_EXPORT___;
